import { MouseIcon, TriangleArrowDownIcon } from "@/shared/icons";

export default function CreateCharacterHotkeys() {
  return (
    <div className="font-medium flex flex-col items-start gap-1">
      <div className="flex items-center gap-2.5">
        <div className="h-10.5 flex items-center justify-center rounded-lg aspect-square bg-[#130F14]/[.84]">
          <MouseIcon size={20} />
        </div>
        <div>Вращение камеры</div>
      </div>
      <div className="flex items-center gap-2.5">
        <div className="h-10.5 flex items-center justify-center rounded-lg aspect-square bg-[#130F14]/[.84] font-extrabold text-xxs">
          M
        </div>
        <div>Вкл/Выкл звук</div>
      </div>
      <div className="flex items-center gap-2.5">
        <div className="h-10.5 flex items-center justify-center rounded-lg px-4 bg-[#130F14]/[.84] font-extrabold uppercase text-xxs">
          Space
        </div>
        <div>Далее</div>
      </div>
      <div className="flex items-center gap-2.5">
        <div className="h-10.5 flex items-center justify-center rounded-lg px-4 bg-[#130F14]/[.84] font-extrabold uppercase text-xxs">
          ESC
        </div>
        <div>Назад</div>
      </div>
      <div className="flex items-center gap-2.5">
        <div className="flex gap-1">
          <div className="h-10.5 aspect-square flex items-center justify-center rounded-lg  bg-[#130F14]/[.84]">
            <TriangleArrowDownIcon size={10} className="-rotate-180" />
          </div>
          <div className="h-10.5 aspect-square flex items-center justify-center rounded-lg  bg-[#130F14]/[.84]">
            <TriangleArrowDownIcon size={10} />
          </div>
        </div>
        <div>Навигация в меню</div>
      </div>
      <div className="flex items-center gap-2.5">
        <div className="flex gap-1">
          <div className="h-10.5 aspect-square flex items-center justify-center rounded-lg  bg-[#130F14]/[.84]">
            <TriangleArrowDownIcon size={10} className="rotate-90" />
          </div>
          <div className="h-10.5 aspect-square flex items-center justify-center rounded-lg  bg-[#130F14]/[.84]">
            <TriangleArrowDownIcon size={10} className="-rotate-90" />
          </div>
        </div>
        <div>Изменение параметров</div>
      </div>
    </div>
  );
}
